<!-- 热门模拟交易调仓动态 -->
<template>
  <div class="tcdtMore" :class="$route.query.themeStyleVs === 2 ? 'black_theme' : 'white_theme'">
    <div class="tcdtMore-nav">
      <van-nav-bar title="热门模拟交易调仓动态" left-arrow @click-left="onClickLeft" />
    </div>

    <div class="content">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          :error.sync="error"
          error-text="请求失败，点击重新加载"
        >
          <ul class="list">
            <li
              v-for="(item, index) in tcdtList"
              :key="index"
              class="list_li"
              @click="goMnDetail(item)"
            >
              <div class="l_title">
                <p class="decorate"></p>

                <!-- 买卖标志：B－买；S－卖 -->
                <span
                  class="state"
                  v-if="item.buySell == 'B'"
                  :style="
                    $route.query.themeStyleVs == 2 ? 'background: #9A2D31' : 'background: #f58888'
                  "
                  >调入</span
                >
                <span
                  class="state"
                  v-else
                  :style="
                    $route.query.themeStyleVs == 2 ? 'background: #1B723D' : 'background:#78cd95'
                  "
                  >调出</span
                >
                <span class="time">{{ formatTradeRecordDate(item.dealTime) }}</span>
              </div>

              <div class="l_content">
                <div class="c_top">
                  <div class="name">
                    <p class="van-ellipsis">{{ item.name }}</p>

                    <van-button
                      size="mini"
                      :color="item.isGz ? '#999' : '#286DF7'"
                      plain
                      @click.stop="favorFn(item, item.capitalId)"
                      >{{ item.isGz ? '已关注' : '关注' }}</van-button
                    >
                  </div>

                  <div class="num">
                    <p>
                      <span>创建后收益</span>
                      <span :class="[judgeColor(item.totalRisk)]">
                        &nbsp;{{ toFixedNum(item.totalRisk * 100, 2, '%') }}
                      </span>
                    </p>

                    <p>
                      <span>最大回撤</span>
                      <span>&nbsp;{{ toFixedNum(item.maxRetreatRate * 100, 2, '%') }}</span>
                    </p>
                  </div>
                </div>

                <ul
                  class="c_bottom"
                  :style="
                    item.stockDeals.length > 3 || item.isCollapse ? 'padding-bottom:0.4rem' : ''
                  "
                >
                  <template v-if="!item.isCollapse">
                    <li v-for="(item2, index) in item._stockDeals" :key="index">
                      ·&nbsp;
                      <span class="name van-ellipsis" v-if="!isVip && compareVersions($route.query.version , 9.71) "
                        >****</span
                      >
                      <span class="name van-ellipsis" v-else>{{ item2.stockName }}</span>
                      <span class="num"
                        >价格 <i>{{ toFixedNum(item2.price, 2, '') }}</i></span
                      >
                      <span class="num"
                        >数量 <i>{{ item2.amount }}</i></span
                      >
                      <span class="num" style="margin: 0" v-if="item.buySell == 'S'">
                        &nbsp;平仓盈亏
                        <!-- <i :class="[judgeColor(item2.profit)]">{{
                          toFixedNum(item2.profit, 2, '%')
                        }}</i> -->

                        <i :class="[judgeColor(item2.profit)]">
                          &nbsp;{{
                            toFixedNum(
                              (item2.profit / (item2.amount * item2.price - item2.profit)) * 100,
                              2,
                              '%'
                            )
                          }}
                        </i>
                      </span>
                    </li>
                  </template>

                  <template v-else>
                    <li v-for="(item2, index) in item.stockDeals" :key="index">
                      ·&nbsp;
                      <span class="name van-ellipsis" v-if="!isVip && compareVersions($route.query.version , 9.71) "
                        >****</span
                      >
                      <span class="name van-ellipsis" v-else>{{ item2.stockName }}</span>
                      <span class="num"
                        >价格 <i>{{ toFixedNum(item2.price, 2, '') }}</i></span
                      >
                      <span class="num"
                        >数量 <i>{{ item2.amount }}</i></span
                      >
                      <span class="num" style="margin: 0" v-if="item.buySell == 'S'">
                        &nbsp;平仓盈亏
                        <!-- <i :class="[judgeColor(item2.profit)]">{{
                          toFixedNum(item2.profit, 2, '%')
                        }}</i> -->

                        <i :class="[judgeColor(item2.profit)]">
                          &nbsp;{{
                            toFixedNum(
                              (item2.profit / (item2.amount * item2.price - item2.profit)) * 100,
                              2,
                              '%'
                            )
                          }}
                        </i>
                      </span>
                    </li>
                  </template>

                  <div
                    class="groundGlass"
                    @click="showVIP"
                    v-if="!isVip && compareVersions($route.query.version , 9.71) "
                  >
                    <img src="@/assets/image/homeVIP.png" alt="" />
                  </div>
                </ul>
                <p
                  class="all"
                  @click.stop="expandContent(index)"
                  v-if="item.stockDeals.length > 3 && !item.isCollapse"
                >
                  展开全部
                </p>

                <p class="all" v-if="item.isCollapse" @click.stop="collapseContent(index)">收起</p>
              </div>
            </li>
          </ul>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { getHotdynamicsMore, addMyFavor, delMyFavor } from '@/api/index.js';
import { judgeColor, toFixedNum, formatTradeRecordDate,compareVersions } from '@/utils/format';
import mixin from '@/mixins/index.js';

export default {
  name: 'TcdtMore',
  mixins: [mixin],
  props: [],

  data() {
    return {
      isVip: false,
      tcdtList: [],
      stockNum: 3,
      loading: false,
      finished: false,
      refreshing: false,
      pageNo: 0,
      error: false
    };
  },
  filters: {},
  created() {},
  watch: {
    '$store.state.isVip': {
      handler(newValue) {
        this.isVip = newValue;
      },
      immediate: true // 立即执行一次
    }
  },
  async mounted() {},
  methods: {
    judgeColor,
    toFixedNum,
    formatTradeRecordDate,
    compareVersions,

    onClickLeft: function () {
      this.$router.go(-1);
    },

    onLoad: function () {
      this.pageNo++;
      this.getHotdynamicsMoreFun();
    },

    // 获取热门模拟交易调仓动态
    getHotdynamicsMoreFun: function () {
      let _this = this;

      let obj = {
        pageNo: _this.pageNo,
        pageSize: 20
      };
      getHotdynamicsMore(obj)
        .then((res) => {
          if (_this.refreshing) {
            _this.tcdtList = [];
            _this.refreshing = false;
          }

          if (res.err === 200) {
            _this.tcdtList.push(...res.data.list);
            _this.loading = false;

            _this.tcdtList.forEach((item) => {
              item.isCollapse = false;

              if (item.stockDeals.length > 3) {
                item._stockDeals = item.stockDeals.slice(0, 3);
              } else {
                item._stockDeals = item.stockDeals;
              }
            });

            if (res.data.list.length < 20) {
              _this.finished = true;
            } else {
              _this.finished = false;
            }
          } else {
            _this.error = true;
          }
        })
        .catch(() => {
          _this.error = true;
        });
    },

    onRefresh() {
      this.pageNo = 0; //页码归零
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },

    hint: function () {
      this.$dialog
        .alert({
          message: 'XXXXXX'
        })
        .then(() => {
          // on close
        });
    },

    //点击vip遮罩
    showVIP: function () {
      let appJson = {
        channel: 'yinzi',
        dzhadid: '0705'
      };
      DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
        'factorNoVipPerDialog',
        JSON.stringify(appJson),
        ''
      );
    },

    // 点击关注、已关注按钮
    favorFn: function (item, capitalId) {
      if (item.isGz) {
        this.delFavorFn(item, capitalId);
      } else {
        this.addFavorFn(item, capitalId);
      }
    },
    // 加入关注
    // 1 策略 2 因子 3 模拟盘
    // "2", //类型2-策略  "1",  // 类型1-因子 3 模拟盘
    addFavorFn: function (item, capitalId) {
      let that = this;

      that.$toast.loading({
        message: '加载中...',
        duration: 0,
        forbidClick: true
      });

      let obj = {
        type: 3,
        id: item.capitalId,
        s_name: item.name,
        f_id_arr: item.capitalId,
        creator: '',
        counter_num: item.counterCode
      };
      addMyFavor(obj).then((res) => {
        if (res.err === 200) {
          that.tcdtList.forEach((item) => {
            if (item.capitalId === capitalId) {
              item.isGz = true;
            }
          });
          that.$toast('关注成功');
        } else {
          that.$toast(res.msg);
        }
      });
    },
    // 取消关注
    delFavorFn: function (item, capitalId) {
      let that = this;

      that.$toast.loading({
        message: '加载中...',
        duration: 0,
        forbidClick: true
      });

      let obj = {
        type: 3,
        id: item.capitalId
      };
      delMyFavor(obj).then((res) => {
        if (res.err === 200) {
          that.tcdtList.forEach((item) => {
            if (item.capitalId === capitalId) {
              item.isGz = false;
            }
          });
          that.$toast('取消关注成功');
        } else {
          that.$toast(res.msg);
        }
      });
    },

    expandContent: function (index) {
      this.$set(this.tcdtList[index], 'isCollapse', true);
      this.$forceUpdate();
    },

    collapseContent: function (index) {
      this.$set(this.tcdtList[index], 'isCollapse', false);
      this.$forceUpdate();
    },

    // 跳转模拟详情
    goMnDetail: function (item) {
      // 判断是否是 vip
      if(this.isVip == false && compareVersions(this.$route.query.version , 9.92) ) {
        let appJson = {
          DialogType: "basic",
        };
        DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
          'factorTYPerDialog',
          JSON.stringify(appJson),
          ''
        );
      } else if (this.isVip == false && compareVersions(this.$route.query.version , 9.71) ) {
        // 如果不是VIP用户,弹出VIP提示
        let appJson = {
          channel: 'yinzi',
          dzhadid: '0705'
        };
        DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
          'factorNoVipPerDialog',
          JSON.stringify(appJson),
          ''
        );
      } else {
        location.href = '/mnDetail?DZHSPECIAL=4325641&type=hot&zj_id=' + item.capitalId;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.tcdtMore {
  .tcdtMore-nav {
    ::v-deep {
      .van-hairline--bottom::after {
        display: none;
      }

      .van-nav-bar {
        padding-top: 40px;
        background: none;
      }

      .van-nav-bar__left,
      .van-nav-bar__right {
        padding: 0 16px;
      }

      .van-icon,
      .van-nav-bar__title {
        color: #333;
      }
    }
  }

  .content {
    height: calc(100vh - 86px);
    overflow-y: auto;
    .list {
      border-left: 1px dashed #e5e5e5;
      margin-left: 16px;
      .list_li {
        padding: 0 15px;
        .l_title {
          display: flex;
          align-items: center;
          margin-top: 18px;
          position: relative;
          .decorate {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            border: 2px solid #999;
            background: #fff;
            position: absolute;
            top: 5px;
            left: -19px;
          }

          .state {
            padding: 0 4px;
            color: #fff;
            font-size: 11px;
            border-radius: 4px;
          }
          .time {
            margin-left: 8px;
            color: #555;
            font-size: 14px;
            font-weight: 600;
          }
        }
        .l_content {
          border: 1px solid #e5e5e5;
          margin-top: 6px;
          border-radius: 8px;
          position: relative;
          .c_top {
            padding: 8px 12px;
            border-bottom: 1px solid #e5e5e5;
            .name {
              display: flex;
              align-items: center;
              justify-content: space-between;
              p {
                color: #555;
                font-size: 16px;
                font-weight: 500;
                width: 250px;
              }
              ::v-deep {
                .van-button {
                  border: none !important;
                  height: auto !important;
                  background: none !important;
                  border: none !important;
                  // color: #286df7 !important;
                }

                .van-button--default {
                }

                .van-button__text {
                  font-size: 12px;
                }
              }
            }

            .num {
              display: flex;
              align-items: center;
              p {
                width: 50%;
                margin-top: 5px;
                span {
                  &:first-child {
                    color: #999;
                    font-size: 12px;
                    font-weight: 400;
                  }

                  &:last-child {
                    color: #555;
                    font-size: 14px;
                    font-weight: 600;
                  }
                }
              }
            }
          }

          .c_bottom {
            background: #f7f8fa;
            padding: 6px 12px;
            position: relative;
            line-height: 20px;
            border-radius: 0px 0px 8px 8px;
            li {
              display: flex;
              align-items: center;
              flex-wrap: wrap;
              &:last-child {
                margin: 0;
              }

              .name {
                color: #555;
                font-size: 12px;
                font-weight: 500;
                flex-shrink: 0;
                width: 65px;
              }
              .num {
                color: #999;
                font-size: 11px;
                font-weight: 400;
                // width: 100%;
                margin-right: 12px;
                i {
                  color: #555;
                  font-size: 11px;
                  font-weight: 400;
                  font-style: normal;
                }
                &:last-child {
                  // width: 110px;
                  flex-shrink: 0;
                  margin-right: 0;
                }
              }
            }

            .groundGlass {
              backdrop-filter: blur(5px); /* 标准写法 */
              position: absolute;
              z-index: 9;
              top: 0px;
              left: 15px;
              width: 40px;
              height: 100%;
              text-align: center;
              display: flex;
              align-items: center;
              justify-content: center;
              img {
                width: 40px;
                height: 26px;
                margin-left: 4px;
              }
            }
          }
          .all {
            color: #286df7;
            font-size: 11px;
            font-weight: 400;
            position: absolute;
            right: 12px;
            bottom: 2px;
          }
        }
      }
    }
  }
}
</style>

<!-- 黑色主题 -->
<style lang="less" scoped>
.black_theme {
  background: #1a1c26;

  .tcdtMore-nav {
    ::v-deep {
      .van-icon,
      .van-nav-bar__title {
        color: #fff;
      }
    }
  }

  .content {
    .list {
      border-left: 1px dashed #424956;
      .list_li {
        .l_title {
          .time {
            color: #e4e9fe;
          }
        }
        .decorate {
          border: 2px solid #6b7687;
        }
        .l_content {
          background: #272935;
          border: 1px solid #2f3448;
          ::v-deep {
            .van-button {
              background: none;
            }
          }
          .c_top {
            border-bottom: 1px solid #2f3448;
            .name {
              p {
                color: #e4e9fe;
              }
            }
            .num {
              p {
                span {
                  &:first-child {
                    color: #6b7687;
                  }
                  &:last-child {
                    color: #aab9d1;
                  }
                }
              }
            }
          }
          .c_bottom {
            background: #2d2f3b;
            li {
              color: #aab9d1;
              .name {
                color: #aab9d1;
              }
              .num {
                color: #6b7687;
                i {
                  color: #aab9d1;
                }
              }
            }
          }
          .all {
            background: #2d2f3b;
          }
        }
      }
    }
  }
}
</style>
